<template>
  <div class="window">
    <div class="window__content">
      <div v-if="title" class="window__title">{{ title }}</div>
      <slot></slot>
    </div>
  </div>

</template>

<script>
export default {
    name:"WindowModal",
    props: { title: String },
}
</script>

<style scoped>
        .window {
            position: fixed;
            width: 100vw;
            height: 100vh;
            display: flex;
            top:0;
            align-items: flex-end;
            background: rgba(19, 70, 47, 0.8);
        }

        .window__content {
            position: relative;
            left: 0;
            right: 0;
            bottom: 86px;
            width: 90%;
            max-width: 400px;
            min-height: 286px;
            margin: 0 auto;
            background: #F8F1EB;
            border-radius: 9px;
            overflow: hidden;
        }

        .window__title {
            margin: 16px 0 20px;
            font-weight: 600;
            font-size: 18px;
            line-height: 26px;
            text-align: center;
            color: #012535;
        }

        @media (min-width: 768px) {
            .window {
                align-items: center;

            }
        }
</style>